// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__mA38w","cart_amount":"Cart_cart_amount__DfUmQ","cart_amountNumber":"Cart_cart_amountNumber__93Rm4","cart_amountIcon":"Cart_cart_amountIcon__Napi5"};